import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import QA from './QA.json';
import PracticeQFStyle from '../styles&pics/PractriceQFStyle';
import Captcha from '../UtilityComponents/Captcha';

function PracticeQForm() {
  const [isVerified, setIsVerified] = useState(false);
  const [hp, setHp] = useState(null);

  const navigate = useNavigate();
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const eidos = query.get('eidos');
  const erid = query.get('erid');

  const tableData = QA.find(item => item.name === eidos).data;
  const question = tableData.find(item => item.erid === erid);
  const questionId = question.erid;
  const questionText = question.erwthsh;
  let answerText = question.apanthsh;
  let answerCode = question.code_content;
  const answerValue = question.Vathmos;
  const answerPicpaths = question.Path;

  console.log(answerText);
  console.log(answerCode);

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    if (formData.get(hp) !== null) {
      return;
    }

    const useranswer = formData.get('answer');
    const usercode = formData.get('answercode');
    const userimg = formData.get('answerimg');

    navigate('/AnswerLoader', {
      state: {
        answerText,
        useranswer,
        usercode,
        userimg,
        answerCode,
        answerValue,
        answerPicpaths,
      },
    });
  };

  return (
    <>
      <PracticeQFStyle />
      <main className="question-main">
        <div className="question-container">
          <div className="question-card">
            <div className="question-header">
              <p className="question-type">
                Διαλέξατε την {eidos === "vasikes" ? "γενική" : "ειδική"} ερώτηση με αριθμό
              </p>
              <p className="question-number">{questionId}</p>
            </div>

            <div className="question-text-container">
              <p className="question-text">{questionText}</p>
            </div>

            <p className="answer-prompt">Δώσε την απάντησή σου:</p>

            <form className="question-form" onSubmit={handleSubmit}>
              {answerText && (
                <textarea
                  name="answer"
                  placeholder="Δώσε την απάντησή σου.."
                  onChange={() => {}}
                  rows="4"
                  cols="100"
                  className="answer-textarea"
                />
              )}

              {answerCode && (
                <textarea
                  name="answercode"
                  placeholder="Γράψε τον κώδικά σου.."
                  onChange={() => {}}
                  rows="4"
                  cols="100"
                  className="answer-textarea"
                />
              )}

              {answerPicpaths && (
                <div className="file-input-container">
                  <p className="file-instruction">Η απάντηση να δοθεί με αρχείο εικόνας</p>
                  <input
                    id="image"
                    placeholder="Δώσε την απάντησή σου.."
                    type="file"
                    name="answerimage"
                    accept="image/png, image/jpg"
                    onChange={() => {}}
                    className="file-input"
                  />
                </div>
              )}

              <label style={{ display: 'none' }}>
                <input type="text" value={hp} onChange={(e) => setHp(e.target.value)} />
              </label>

              <Captcha onVerify={() => setIsVerified(true)} isVerified={isVerified} />

              <div className="button-group">
                <input
                  type="submit"
                  value={!isVerified ? "⏱" : "Υποβολή Απάντησης"}
                  disabled={!isVerified}
                  className="submit-btn"
                />
                <input type="reset" value="Καθαρισμός" className="reset-btn" />
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default PracticeQForm;